export default {
      id: "ic_nav_mp-usage",
      viewBox: "0 0 35 30",
      url: "/" + "images/icons.3.109.2.svg#ic_nav_mp-usage",
      toString: function () {
        return this.url;
      }
    }